export default __webpack_public_path__ + "img/edylFAOk.d2c7fa5d.svg";